import ProductCard from "./ProductCard.jsx";
import useFetchProducts from "../../hooks/useFetchProducts.js";
import { useTranslation } from "react-i18next";
import { Skeleton } from "antd";

export default function NewProductsBanner() {
    const { t } = useTranslation('newProductsCard');
    const { products, loading } = useFetchProducts();

    const filteredNewProducts = products ? products.filter(product => product.is_new) : [];

    if (filteredNewProducts.length === 0) {
        return null;
    }

    return (
        <div className="pt-10">
            <h2 className="font-bold text-2xl mb-6">{t("freshArrivals")}</h2>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                {loading ? (
                    [...Array(4)].map((_, index) => (
                        <Skeleton.Node
                            key={index}
                            active
                            shape="square"
                            size="large"
                            style={{
                                width: "100%",
                                height: "220px",
                            }}
                            className="w-full sm:w-[200px] md:w-[260px] lg:w-[260px]"
                        />
                    ))
                ) : (
                    filteredNewProducts.map((product) => (
                        <ProductCard key={product.id} product={product} />
                    ))
                )}
            </div>
        </div>
    );
}
